import { Unit } from '@/types';
import { useTheme } from 'styled-components';
import { Inline, InlineItem, Icon, Text, Stack, Strong } from '@kinesis/bungle';
import { renderValue, renderUnit } from '@/data/units';
import {
  Indicator,
  IndicatorValue,
  PolicyType,
} from './budget-indicator.styles';

const policyNames = {
  current: 'Current\u00a0settings',
  intermediate: 'Intermediate',
  aggressive: 'Aggressive',
};

const BudgetIndicator = (props: BudgetIndicatorProps) => {
  const { policy, unit, value } = props;
  const theme = useTheme() as any;
  const policyName = policyNames[policy];

  return (
    <Indicator>
      <Stack space='medium' alignX='center'>
        <Stack space='xsmall'>
          <IndicatorValue>
            {value > 0 && '+'}
            {renderValue(value, unit)}
          </IndicatorValue>
          <Text>{renderUnit(unit)}</Text>
        </Stack>
        <Inline space='small'>
          <InlineItem>
            <Icon
              magnitude='small'
              type='circle'
              color={
                value < 0 ? theme.color.layer.yellow.fill : theme.color.green6
              }
            />
          </InlineItem>
          <InlineItem>
            <PolicyType>
              <Strong>{policyName}</Strong>
            </PolicyType>
          </InlineItem>
        </Inline>
      </Stack>
    </Indicator>
  );
};

export type BudgetIndicatorProps = {
  policy: 'current' | 'intermediate' | 'aggressive';
  unit: Unit;
  value: number;
};

export { BudgetIndicator };
